"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResolvedValueMetadataInjectOptions = isResolvedValueMetadataInjectOptions;
const common_1 = require("@inversifyjs/common");
function isResolvedValueMetadataInjectOptions(options) {
    return typeof options === 'object' && !common_1.LazyServiceIdentifier.is(options);
}
//# sourceMappingURL=isResolvedValueMetadataInjectOptions.js.map